import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ReportCopyComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-copy.component";
import { ReportSelectorComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-selector.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { FiscalYear, SaveReportFile, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { Observable } from "rxjs";
import { take, takeUntil } from "rxjs/operators";

@Component({
  selector: "new-daily-purchase-invoice-report",
  templateUrl: "new-daily-purchase-invoice-report.component.html",
  styleUrls: ["new-daily-purchase-invoice-report.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDailyPurchaseInvoiceReportComponent extends BaseFormComponent<any> {
  public apiName: string = "InventoryReview";
  public label: string = "گزارش فاکتور خرید روزانه جدید";
  constructor(
    private missetup: MisSetupService,
    __id: FormContainerModel,
    _tabsservice: TabularService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef
  ) {
    super(selectorService, cd);
    this.tabsservice = _tabsservice;
    this._id = __id;
  }
  async ngOnInit() {
    this.ReportSelectorForm = ReportSelectorComponent;
    this.ReportCopyForm = ReportCopyComponent;
    this.reportName = "GetNewDailyPurchaseInvoiceReport";
    this.pathPreFix = "INV";
    this.apiName = "InventoryReview";
    this.areaName = "Inventory";
    this.loadReports();
    super.ngOnInit();
  }

  async setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: "سال مالی",
      controlType: FormControlTypes.dropdown,
      modelName: "FiscalYearId",
      disabled: false,
      name: "FiscalYearId",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Id",
      displayMember: "Year",
    });
    this.columns.push(<form_control>{
      label: "تاریخ",
      controlType: FormControlTypes.datePicker,
      modelName: "VoucherDate",
      disabled: false,
      name: "VoucherDate",
      order: 2,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.orignalColumns = this.columns;
  }
  addControl(): void {
    this.setValue("Key", "GL");
    this.setValue("VoucherDate", new Date());
    if (this.accountService.authService.currentFiscalYear) {
      this.setValue("FiscalYearId", this.accountService.authService.currentFiscalYear.Id);
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x: FiscalYear) => {
        if (x && x.StartDate) {
          this.setValue("FiscalYearId", x.Id);
        }
      });
  }
  changeReport(reprtName: string): void {
    if (!this.apiName) return;
    let saveReportFile: SaveReportFile = <SaveReportFile>{};
    saveReportFile.ReportTitle = this.label;
    saveReportFile.FileName = this.reportName;
    if (this.VoucherKind?.VoucherKindId) saveReportFile.FileName = `${this.reportName}_${this.VoucherKind?.VoucherKindId}`;

    saveReportFile.SystemKindName = this.pathPreFix;
    if (this.VoucherKind?.VoucherKindId) saveReportFile.SystemKindName = `${this.pathPreFix}_${this.VoucherKind?.VoucherKindId}`;

    saveReportFile.CategoryName = this.apiName.replace("/", "_");
    if (this.reportList && this.reportList.length > 1) {
      this.dialogService
        .open(
          this.ReportSelectorForm,
          { dataList: this.reportList, currentrow: null, apiName: this.apiName, areaName: this.areaName, label: "انتخاب گزارش" },
          { autoFocus: true, closeOnEscape: false, closeOnClickOutside: false }
        )
        .pipe(take(1))
        .subscribe((model: any) => {
          if (model) {
            saveReportFile = model;
            this.loadData(reprtName, saveReportFile);
          }
        });
      this.currentReport = "print";
      return;
    }
    if (this.reportList && this.reportList.length === 1) {
      saveReportFile = this.reportList[0];
    } else {
      this.reportList = [];
      this.reportList.push(saveReportFile);
    }
    this.loadData(reprtName, saveReportFile);
  }
  loadData(reportName: string, saveReportFile: SaveReportFile) {
    let filter: GridFilter[] = [];
    filter.push({
      Type: "F",
      Filed: "FiscalYearId",
      Value: this.formGroup.get("FiscalYearId").value,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    filter.push({ Type: "F", Filed: "VoucherDate", Value: this.formGroup.get("VoucherDate").value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    this.httpCommonService
      .GetFilterGrid("InventoryReview/GetNewDailyPurchaseInvoiceReport", filter)
      .pipe(take(1))
      .toPromise()
      .then(
        (data) => {
          this.setReport(reportName, saveReportFile, data as []);
        },
        (error) => {
          console.log(error);
        }
      );
  }
  canDeactivate(): boolean | Observable<boolean> {
    return true;
  }
}
